import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import SupplyChain from '@/supplychain/components/SupplyChain'
import SupplyChainAnnouncement from '@/supplychain/components/SupplyChainAnnouncement'
import SupplyChainGraph from '@/supplychain/components/SupplyChainGraph'
import SupplyChainAreaMap from '@/supplychain/components/SupplyChainAreaMap'
import Suppliers from '@/supplychain/components/Suppliers'
import Customers from '@/supplychain/components/Customers'
import ESGEntityRating from '@/esg/components/ESGEntityRating'
import ESGPrivateEntityIndicator from '@/esg/components/ESGPrivateEntityIndicator'
import ESGEntityIndicatorMonth from '@/esg/components/ESGEntityIndicatorMonth'
import ESGEntityIndicatorAnnual from '@/esg/components/ESGEntityIndicatorAnnual'
import ESGBondissuerIndicatorAnnual from '@/esg/components/ESGBondissuerIndicatorAnnual'
import ESGEntityNews from '@/esg/components/ESGEntityNews'
import ESGIndustry from '@/esg/components/ESGIndustryRating'
import Entity from '@/entity/components/Entity'
import EntityHome from '@/entity/components/EntityHome'
import ESGEventList from '@/esg/components/ESGEventList'
import ESGPublicSentiment from '@/esg/components/ESGPublicSentiment'
import ESGPublicSentimentDetail from '@/esg/components/ESGPublicSentimentDetail'
import ESGHome from '@/esg/components/ESGHome'
import NewEnergy from '@/supplychain/components/NewEnergy'
import Driverless from '@/supplychain/components/Driverless'
import EventHome from '@/event/components/EventHome'
import CompareHome from '@/compare/components/CompareHome'
import Influence from '@/supplychain/components/ScInfluence'
import FiveG from '@/supplychain/components/FiveG'
import SimilaritySearch from '@/patent/components/SimilaritySearch'
import TechniqueFieldSearch from '@/patent/components/TechniqueFieldSearch'
import PatentDetail from '@/patent/components/PatentDetail'
import Login from '@/home/components/Login'
import GzjrfzLogin from '@/home/components/GzjrfzLogin'
import ApplyUser from '@/home/components/ApplyUser'
import GzjrfzApplyUser from '@/home/components/GzjrfzApplyUser'
import EsgFilter from '@/esg/components/ESGFilter'
import Home from '@/home/components/Home'
import UserCenter from '@/user_center/components/UserCenter'
import DriverlessCompany from '@/supplychain/components/DriverlessCompany'
import SFDRUpload from '@/sfdr/components/SFDRUpload'
import SFDRReport from '@/sfdr/components/SFDRReport'
import SFDRCoverage from '@/sfdr/components/SFDRCoverageDetails'
import InsuranceESGUpload from '@/insurance_esg/components/InsuranceESGUpload'
import InsuranceESGReport from '@/insurance_esg/components/InsuranceESGReport'
import InsuranceESGDetails from '@/insurance_esg/components/InsuranceESGDetails'
import InsuranceESGMap from '@/insurance_esg/components/InsuranceESGMap'
import InsuranceESGRanking from '@/insurance_esg/components/InsuranceESGRanking'
// import UserProfile from '@/user_center/components/UserProfile'
// import FavoriteCompanies from '@/user_center/components/FavoriteCompanies'
import EditPassword from '@/user_center/components/EditPassword'
import Authority from '@/user_center/components/Authority'
import FollowCompany from '@/user_center/components/FollowCompany'
import PollutionHome from '@/pollution/components/PollutionHome'
import LicenseDetail from '@/pollution/components/LicenseDetail'
import PollutantEmission from '@/pollution/components/PollutantEmission'
import FundESGIndicators from '@/fund_esg/components/FundESGIndicators'
import FundESGRating from '@/fund_esg/components/FundESGRating'
import FundESGCompare from '@/fund_esg/components/FundESGCompare'
import CarbonData from '@/carbon/components/CarbonData'
import CarbonHome from '@/carbon/components/CarbonHome'
import RecentReport from '@/research_report/components/RecentReport'
import ReportDetails from '@/research_report/components/ReportDetails'
import TopicSearch from '@/research_report/components/TopicSearch'
import ReportRanking from '@/research_report/components/ReportRanking'
import IndustrialChainFilter from '@/supplychain/components/IndustrialChainFilter'
import RevenueBreakdown from '@/supplychain/components/RevenueBreakdown'
import ESGEntityReportDownload from '@/esg/components/ESGEntityReportDownload'
import ESGReportDownload from '@/esg/components/ESGReportDownload'
import ReportDownloadHistory from '@/user_center/components/ReportDownloadHistory'
import ProductFilter from '@/supplychain/components/ProductFilter'
import EmailPush from '../user_center/components/EmailPush.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      meta: {
        requireAuth: true
      },
      component: Home
    },
    {
      path: '/usercenter/',
      meta: {
        requireAuth: true
      },
      component: UserCenter,
      children: [
        // {
        //   path: 'profile',
        //   meta: {
        //     requireAuth: true
        //   },
        //   component: UserProfile
        // },
        // {
        //   path: 'favoritecompanies',
        //   meta: {
        //     requireAuth: true
        //   },
        //   component: FavoriteCompanies
        // },
        {
          path: 'password',
          name: 'password',
          meta: {
            requireAuth: true
          },
          component: EditPassword
        },
        {
          path: 'authority',
          name: 'authority',
          meta: {
            requireAuth: true
          },
          component: Authority
        },
        {
          path: 'followcompany',
          name: 'followcompany',
          meta: {
            requireAuth: true
          },
          component: FollowCompany
        },
        {
          path: 'downloadhistory',
          name: 'downloadhistory',
          meta: {
            requireAuth: true
          },
          component: ReportDownloadHistory
        }
        ,
        {
          path: 'emailpush',
          name: 'emailpush',
          meta: {
            requireAuth: true
          },
          component: EmailPush
        }
      ]
    },
    {
      path: '/comparehome',
      meta: {
        requireAuth: true
      },
      component: CompareHome
    },
    {
      name: 'eventhome',
      path: '/eventhome',
      meta: {
        requireAuth: true
      },
      component: EventHome
    },
    {
      path: '/supplychaingraph',
      meta: {
        requireAuth: true
      },
      component: SupplyChainGraph
    },
    {
      path: '/newenergy',
      meta: {
        requireAuth: true
      },
      component: NewEnergy
    },
    {
      path: '/fiveg',
      meta: {
        requireAuth: true
      },
      component: FiveG
    },
    {
      path: '/driverless',
      meta: {
        requireAuth: true
      },
      component: Driverless
    },
    {
      path: '/driverlesscompany',
      meta: {
        requireAuth: true
      },
      component: DriverlessCompany
    },
    {
      path: '/industrialChainFilter',
      meta: {
        requireAuth: true
      },
      component: IndustrialChainFilter
    },
    {
      path: '/productFilter',
      meta: {
        requireAuth: true
      },
      component: ProductFilter
    },
    {
      path: '/gzjrfzlogin',
      component: GzjrfzLogin
    },
    {
      path: '/gzjrfzapplyuser',
      component: GzjrfzApplyUser
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/applyuser',
      component: ApplyUser
    },
    {
      path: '/supplychain',
      meta: {
        requireAuth: true
      },
      component: SupplyChain
    },
    {
      path: '/SupplyChainAnnouncement',
      meta: {
        requireAuth: true
      },
      component: SupplyChainAnnouncement
    },

    {
      path: '/entity/:oaid/',
      meta: {
        requireAuth: true
      },
      component: Entity,
      children: [
        {
          path: 'home',
          meta: {
            requireAuth: true
          },
          component: EntityHome
        },
        {
          path: 'esg/indicator/month',
          meta: {
            requireAuth: true
          },
          component: ESGEntityIndicatorMonth
        },
        {
          path: 'esg/privateentity/indicator',
          meta: {
            requireAuth: true
          },
          component: ESGPrivateEntityIndicator
        },
        {
          path: 'esg/rating',
          meta: {
            requireAuth: true
          },
          component: ESGEntityRating
        },
        {
          path: 'esg/indicator/annual',
          meta: {
            requireAuth: true
          },
          component: ESGEntityIndicatorAnnual
        },
        {
          path: 'esg/bondissuer/indicator/annual',
          meta: {
            requireAuth: true
          },
          component: ESGBondissuerIndicatorAnnual
        },
        {
          path: 'esg/news',
          name: 'esgEntityNews',
          meta: {
            requireAuth: true
          },
          component: ESGEntityNews
        },
        {
          path: 'esg/report/download',
          name: 'esgReportDownload',
          meta: {
            requireAuth: true
          },
          component: ESGEntityReportDownload
        },
        {
          path: 'suppliers',
          meta: {
            requireAuth: true
          },
          component: Suppliers
        }
        ,
        {
          path: 'customers',
          meta: {
            requireAuth: true
          },
          component: Customers
        },
        {
          path: 'scmapping',
          meta: {
            requireAuth: true
          },
          component: SupplyChainGraph
        },
        {
          path: 'scinfluence',
          meta: {
            requireAuth: true
          },
          component: Influence
        },
        {
          path: 'scarea',
          meta: {
            requireAuth: true
          },
          component: SupplyChainAreaMap
        },
        {
          path: 'patent/detail',
          meta: {
            requireAuth: true
          },
          component: PatentDetail
        },
        // {
        //   path: 'license/detail',
        //   meta: {
        //     requireAuth: true
        //   },
        //   component: LicenseDetail
        // },
        // {
        //   path: 'pollutant/emission',
        //   meta: {
        //     requireAuth: true
        //   },
        //   component: PollutantEmission
        // },
        {
          path: 'carbon/carbondata',
          meta: {
            requireAuth: true
          },
          component: CarbonData
        },
        {
          path:'report/recent',
          meta:{
            requireAuth:true
          },
          component:RecentReport
        },
        {
          path:'report/details',
          meta:{
            requireAuth:true
          },
          component:ReportDetails
        },
        {
          path: 'revenue/breakdown',
          meta: {
            requireAuth: true
          },
          component: RevenueBreakdown
        }
      ]
    },
    {
      path: '/esgevent',
      meta: {
        requireAuth: true
      },
      component: ESGEventList
    },
    {
      path: '/esgpublicsentiment',
      meta: {
        requireAuth: true
      },
      component: ESGPublicSentiment
    },
    {
      path: '/esgpublicsentiment-detail',
      name: 'newsDetail',
      meta: {
        requireAuth: true
      },
      component: ESGPublicSentimentDetail
    },
    {
      path: '/esgindustry',
      meta: {
        requireAuth: true
      },
      component: ESGIndustry
    },
    {
      path: '/esg',
      meta: {
        requireAuth: true
      },
      component: ESGHome
    },
    {
      path: '/esgperformreportdownload',
      name: 'esgperformreportdownload',
      meta: {
        requireAuth: true
      },
      component: ESGReportDownload
    },
    {
      path: '/esgfilter',
      name: 'esgfilter',
      meta: {
        requireAuth: true
      },
      component: EsgFilter
    },
    {
      path: '/similaritysearch',
      meta: {
        requireAuth: true
      },
      component: SimilaritySearch
    },
    {
      path: '/techniquefieldsearch',
      meta: {
        requireAuth: true
      },
      component: TechniqueFieldSearch
    },
    // {
    //   path: '/pollutionhome',
    //   meta: {
    //     requireAuth: true
    //   },
    //   component: PollutionHome
    // },
    {
      path: '/sfdrupload',
      component: SFDRUpload
    },
    {
      path: '/sfdrreport',
      component: SFDRReport
    },
    {
      path: '/sfdrcoverage',
      component: SFDRCoverage
    },
    {
      path: '/insuranceesgupload',
      component: InsuranceESGUpload
    },
    {
      path: '/insuranceesgreport',
      component: InsuranceESGReport
    },
    {
      name: 'insuranceesgdetails',
      path: '/insuranceesgdetails',
      component: InsuranceESGDetails
    },
    {
      name: 'unsuranceesgmap',
      path: '/insuranceesgmap',
      component: InsuranceESGMap
    },
    {
      path: '/insuranceesgranking',
      component: InsuranceESGRanking
    },
    {
      path: '/fundesgindicators',
      meta: {
        requireAuth: true
      },
      component: FundESGIndicators
    },
    {
      path: '/fundesgrating',
      meta: {
        requireAuth: true
      },
      component: FundESGRating
    },
    {
      path: '/fundesgcompare',
      meta: {
        requireAuth: true
      },
      component: FundESGCompare
    },
    {
      path: '/carbon',
      meta: {
        requireAuth: true
      },
      component: CarbonHome
    },
    // 券商研报--主题词搜索
    {
      path:'/researchreport',
      meta: {
        requireAuth: true
      },
      component:TopicSearch
    },
    // 研报排行榜
    {
      path:'/reportranking',
      meta: {
        requireAuth: true
      },
      component:ReportRanking
    },
    {
      path:'/esgreport',
      meta: {
        requireAuth: true
      },
    },
    {
      path:'/esgreport/*',
      meta: {
        requireAuth: true
      },
    },
    {
      path: '*', // 页面不存在的情况下跳到登录页
      redirect: '/login',
      component: Login
    }
  ]
})


function redirectLogin(){
  let path = '/login'
    if(window.location.hostname === 'gzjrfz.quantdata.com.cn'){
      path = '/gzjrfzlogin'
    }
    return path
}
function checkurl(hostname, path){
  if(path === "/login"){
    if(hostname.endsWith("quantdata.com.cn") && hostname !== 'top.quantdata.com.cn'){
      return true
    }
  }
  return false
}
router.beforeEach((to, from, next) => {
  let tt = new Date().getTime()-30*60*1000
  store.commit('limits/setIsShowMask', false)
  if(checkurl(window.location.hostname, to.path)){
    let path = redirectLogin()
    next({
        path: path,
      })
  }
  if (to.matched.some(res =>res.meta.requireAuth)) {// 判断是否需要登录权限
    if (localStorage.getItem('x-quantdata-auth-id')
        && localStorage.getItem('x-quantdata-auth-timestamp')
        && localStorage.getItem('x-quantdata-auth-token')
    && parseInt(localStorage.getItem('x-quantdata-auth-timestamp'))>tt
    ) {// 判断是否登录
      next()
    } else {// 没登录则跳转到登录界面
      let path = redirectLogin()
      next({
        path: path,
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js